import LayoutAdmin from "../layouts/LayoutAdmin";
import LayoutInicio from "../layouts/LayoutInicio";
import LayoutSistema from "../layouts/LayoutSistema";

import Users from "../pages/Users";
import Reportes from "../pages/Reportes";
import Login from "../pages/Login";
import Error404 from "../pages/404";
import Home from "../pages/Home";

import MenuParticipante from "../pages/MenuParticipante";
import Transferencia from "../pages/Transferencia";

import SistemaLogin from "../pages/Sistema/Login";
import SistemaHome from "../pages/Sistema/Home";
import ReadQR from "../pages/Sistema/ReadQR";
import ReadQRParticipante from "../pages/Sistema/ReadQRParticipante";
import Registrador from "../pages/Registrador";
import Postulante from "../pages/Postulante";
import Participante from "../pages/Participante";
import Asistencia from "../pages/Asistencia";
import Configuracion from "../pages/Configuracion";
import Estructura from "../pages/Estructura";
import Ingresante from "../pages/Ingresante";

const routes = [
  {
    path: "/app",
    component: LayoutAdmin,
    exact: false,
    routes: [
      {
        path: "/app",
        component: Home,
        exact: true
      },
      {
        path: "/app/usuarios",
        component: Users,
        exact: true
      },
      {
        path: "/app/transferencia",
        component: Transferencia,
        exact: true
      },
      {
        path: "/app/reportes",
        component: Reportes,
        exact: true
      },
      {
        path: "/app/registrador",
        component: Registrador,
        exact: true
      },
      {
        path: "/app/postulante",
        component: Postulante,
        exact: true
      },
      {
        path: "/app/ingresante",
        component: Ingresante,
        exact: true
      },
      {
        path: "/app/participante",
        component: Participante,
        exact: true
      },
      {
        path: "/app/asistencia",
        component: Asistencia,
        exact: true
      },
      {
        path: "/app/estructura",
        component: Estructura,
        exact: true
      },
      {
        path: "/app/configuracion",
        component: Configuracion,
        exact: true
      },
      {
        component: Error404
      }
    ]
  },

  {
    path: "/sistema",
    component: LayoutSistema,
    exact: false,
    routes: [
      {
        path: "/sistema",
        component: SistemaHome,
        exact: true
      },
      {
        path: "/sistema/qr",
        component: ReadQR,
        exact: true
      },
      {
        path: "/sistema/qr/participante",
        component: ReadQRParticipante,
        exact: true
      },
      {
        component: Error404
      }
    ]
  },

  {
    path: "/",
    component: LayoutInicio,
    exact: false,
    routes: [
      {
        path: "/",
        component: MenuParticipante,
        exact: true
      },
      {
        path: "/login",
        component: SistemaLogin,
        exact: true
      },
      {
        path: "/auth/login",
        component: Login,
        exact: true
      },
      {
        component: Error404
      }
    ]
  }
];

export default routes;
